/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2477
 */

var r = require(/* 1437 */"./1437")
var i = require(/* 2478 */"./2478/index")
var o = require(/* 2536 */"./2536/index")
var a = require(/* 451 */"../2467/451")
module.exports = function (e, t) {
  return (a(e) ? r : o)(e, i(t, 3))
}
